/** Contraseña fuerte: mínimo 8, mayúscula, minúscula, número y símbolo */

export function getPasswordErrors(password: string): string[] {
  const errors: string[] = [];
  if (password.length < 8) {
    errors.push("Al menos 8 caracteres.");
  }
  if (!/[A-ZÁÉÍÓÚÑ]/.test(password)) {
    errors.push("Al menos una letra mayúscula.");
  }
  if (!/[a-záéíóúñ]/.test(password)) {
    errors.push("Al menos una letra minúscula.");
  }
  if (!/[0-9]/.test(password)) {
    errors.push("Al menos un número.");
  }
  if (!/[^A-Za-zÁÉÍÓÚáéíóúÑñ0-9]/.test(password)) {
    errors.push("Al menos un símbolo (ej. !@#$%).");
  }
  return errors;
}

export function isStrongPassword(password: string): boolean {
  return getPasswordErrors(password).length === 0;
}
